// ======================================================================
// File: src/modules/ppe/components/common/KpiCard.jsx
// Purpose:
//   ERP-grade KPI card with:
//   - 3D elevation
//   - Vertical accent
//   - Status + metric aware icons
// ======================================================================

import React from "react";

// --------------------------------------------------
// Icon Resolver (ERP-safe, no dependency)
// --------------------------------------------------
function resolveIcon(title, value) {
  const v = String(value).toLowerCase();
  const t = String(title).toLowerCase();

  // Status-aware
  if (t.includes("status")) {
    if (v.includes("draft")) return "📝";
    if (v.includes("released")) return "▶️";
    if (v.includes("progress")) return "⚙️";
    if (v.includes("completed")) return "✔️";
    if (v.includes("cancel")) return "✖️";
    return "ℹ️";
  }

  // Metric-aware
  if (t.includes("item")) return "📦";
  if (t.includes("quantity")) return "🔢";
  if (t.includes("boq")) return "📋";
  if (t.includes("routing") || t.includes("operation")) return "🛠️";

  return "📊";
}

export default function KpiCard({ title, value, color = "#0d6efd" }) {
  const icon = resolveIcon(title, value);

  return (
    <div
      style={{
        position: "relative",
        minWidth: 220,
        padding: "16px 18px 16px 22px",
        borderRadius: 12,
        background: "#ffffff",
        boxShadow: "0 6px 16px rgba(0,0,0,0.10)",
        transition: "transform 0.2s ease, box-shadow 0.2s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-3px)";
        e.currentTarget.style.boxShadow =
          "0 10px 22px rgba(0,0,0,0.14)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow =
          "0 6px 16px rgba(0,0,0,0.10)";
      }}
    >
      {/* Vertical Accent */}
      <div
        style={{
          position: "absolute",
          left: 0,
          top: 0,
          bottom: 0,
          width: 5,
          borderTopLeftRadius: 12,
          borderBottomLeftRadius: 12,
          backgroundColor: color,
        }}
      />

      {/* Content */}
      <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
        {/* Icon */}
        <div
          style={{
            fontSize: 28,
            lineHeight: 1,
          }}
        >
          {icon}
        </div>

        {/* Text */}
        <div>
          <div
            style={{
              fontSize: 13,
              fontWeight: 600,
              color: "#6c757d",
              marginBottom: 6,
              textTransform: "uppercase",
              letterSpacing: 0.5,
            }}
          >
            {title}
          </div>

          <div
            style={{
              fontSize: 26,
              fontWeight: 700,
              color: "#212529",
              lineHeight: 1.2,
            }}
          >
            {value}
          </div>
        </div>
      </div>
    </div>
  );
}
